<template>

    <LoopItemPanel title="Categorie selecteren">
        <div class="common-canvas-blocks-custom-quickactions-admin-LoopItemPanel">
            <div class="tw-px-4 tw-py-3 text">
                <div class="tw-mb-1 tw-text-gray-600 label">Link</div>

                <website-page-selector
                        ref="websitePageSelector"
                        :value="loopItem.linkWebsitePageId"
                        :language="'nl' /** TODO **/"
                        @update:value="setLink($event)" />

            </div>

        </div>
    </LoopItemPanel>

</template>

<script>
    import axios from 'axios';
    import LoopItemPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/loop/LoopItemPanel";
    import SwitchInput from "../../../../../../../../packages/lav-galaxy/framework/resources/js/common/canvas/editor/canvas/document/editors/inputs/SwitchInput";
    import WebsitePageSelector from "../../../../../../../../packages/lav-galaxy/framework/resources/js/habitats/admin/common/WebsitePageSelector";

    export default {
        extends: LoopItemPanel,
        components: {
            LoopItemPanel,
            SwitchInput,
            WebsitePageSelector,

        },
        data()
        {
            return {
            };
        },

        methods: {
            setLink(websitePageId)
            {
                // Set
                this.$set(this.loopItem, 'linkWebsitePageId', websitePageId);

                //
                this.linkChanged = true;
            },
        }
    }
</script>
<style lang="scss" scoped>
    .common-canvas-blocks-custom-cases-admin-LoopItemPanel {
    }

</style>